import { UpdateStoreForm } from '@/features/store-management/basic-stores/form/UpdateStoreForm';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/basic-stores/$manage-store/')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="bg-card  p-8 rounded-lg !w-full">
      <UpdateStoreForm />
    </div>
  );
}
